export default "__VITE_ASSET__6MQCagmCrZzS5dHPKhXWKQ__ 220w";